import initialState from './initialState'

const SHOW_SPINNER = (state, boolean) => {
    state.showSpinner = boolean
}

/**
 * @description
 * Returns State to it's initial values
 * @param {*} state
 */
const RESET_STATE = function(state) {
    Object.assign(state, initialState())
}

export default { RESET_STATE, SHOW_SPINNER }
